import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { isConfigured } from '../environments/environment';
@Component({changeDetection: ChangeDetectionStrategy.Eager, selector: 'app-root', imports: [RouterOutlet], templateUrl: './app.component.html', styleUrl: './app.component.css'})
export class AppComponent { readonly configured = isConfigured; }
